import RevenueTypeToken from '@apps/finance/admin/tokens/revenue_type'
import ProjectToken from '@apps/finance/admin/tokens/project'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class New extends React.Component {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    line_item: PropTypes.object,
    onDone: PropTypes.func
  }

  state = {
    line_item: null
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { line_item } = this.props
    return {
      title: 't(Edit Line Item)',
      cancelSvg: 'chevron_left',
      saveText: 't(Done)',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { name: 'id', type: 'hidden', defaultValue: line_item.id },
            { label: 't(Project)', name: 'project_id', type: 'lookup',  endpoint: '/api/admin/finance/memberships', valueKey: 'id', textKey: 'display', required: true, format: ProjectToken, defaultValue: line_item.project_id },
            { label: 't(Revenue Type)', name: 'revenue_type_id', type: 'lookup', endpoint: '/api/admin/finance/revenue_types', valueKey: 'id', textKey: 'display', required: true, format: RevenueTypeToken, defaultValue: line_item.revenue_type_id },
            { label: 't(Description)', name: 'description', required: true, type: 'textfield', defaultValue: line_item.description },
            { label: 't(Quantity)', name: 'quantity', required: true, type: 'numberfield', placeholder: '0.00', defaultValue: line_item.quantity },
            { label: 't(Unit Price)', name: 'price', required: true, type: 'moneyfield', placeholder: '0.00', defaultValue: line_item.price },
            { label: 't(Tax Rate)', name: 'tax_rate', required: true, type: 'ratefield', placeholder: '0.000', defaultValue: line_item.tax_rate },
            { label: 't(Tax Deductible?)', name: 'is_tax_deductible', type: 'checkbox', prompt: 'Is this product tax deductable?', defaultValue: line_item.is_tax_deductible }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.form.pop()
  }

  _handleSuccess(line_item) {
    this.props.onDone(line_item)
    this.context.form.pop()
  }

}

export default New
